import React, { useState, useMemo } from 'react';
import { Card } from 'primereact/card';
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { useGetProductGroupsQuery } from '../../../../api';
import LaborCatalogTable from './components/LaborCatalogTable';
import LaborCatalogDialog from './components/LaborCatalogDialog';
import useLaborCatalog from './hooks/useLaborCatalog';
import GenericTableFilter from '../../../../components/common/GenericTableFilter';
import { useLanguage } from '../../../../contexts/LanguageContext';

const LaborCatalogPage = () => {
    const { th } = useLanguage();
    const [selectedItem, setSelectedItem] = useState(null);
    const [dialogVisible, setDialogVisible] = useState(false);
    const toast = React.useRef(null);
    const [isEdit, setIsEdit] = useState(false);

    const { laborCatalog, isLoading, lazyParams, onPage, saveWarrantyPeriod, handleDelete, activeFilters, handleFilterChange, initFilters } = useLaborCatalog(th);
    const { data: productGroups } = useGetProductGroupsQuery();
    const handleEdit = (rowData) => {
        console.log('rowData:', rowData);
        setSelectedItem(rowData);
        setIsEdit(true);
        setDialogVisible(true);
    };

    const handleHide = () => {
        setDialogVisible(false);
        setSelectedItem(null);
        setIsEdit(false);
    };

    const handleSubmit = async (formData) => {
        const success = await saveWarrantyPeriod(formData);
        if (success) {
            handleHide();
        }
    };
    const filterFields = useMemo(
        () => [
            { field: 'carItemCode', headerName: th('laborCatalog.filters.carItemCode'), type: 'text' },
            { field: 'model', headerName: th('laborCatalog.filters.model'), type: 'text' },
            { field: 'createdDate', headerName: th('laborCatalog.filters.createdDate'), type: 'date' },
            { field: 'productGroup', headerName: th('laborCatalog.table.productGroup'), type: 'select',  options: productGroups?.data || [] }
           
        ],
        
        [th, productGroups?.data] 
    );

    const handleDeleteClick = (id) => {
        confirmDialog({
            message: th('laborCatalog.messages.deleteConfirm'),
            header: th('laborCatalog.messages.deleteHeader'),
            icon: 'pi pi-exclamation-triangle',
            accept: async () => {
                const success = await handleDelete(id);
                if (success) {
                    toast.current.show({
                        severity: 'success',
                        summary: th('common.success'),
                        detail: th('laborCatalog.messages.deleteSuccess'),
                        life: 3000
                    });
                }
            },
            rejectClassName: 'p-button-outlined'
        });
    };

    const handleCreateClick = () => {
        // formData parametresi kaldırıldı, çünkü yeni kayıt için form boş başlatılacak
        setIsEdit(false); // Yeni kayıt modunu false yap
        setSelectedItem(null); // Yeni kayıt için seçili öğeyi sıfırla
        setDialogVisible(true);
    };

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4"></div>
            <Toast ref={toast} />
            <ConfirmDialog />
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('laborCatalog.title')}</h1>
                <Button label={th('laborCatalog.addNew')} icon="pi pi-plus" onClick={handleCreateClick} />
            </div>
            <div className="mb-2">
                <GenericTableFilter filterFields={filterFields} initialFilters={{}} onSearch={() => {}} onApplyFilters={handleFilterChange} onResetFilters={initFilters} />
            </div>
            <LaborCatalogTable data={laborCatalog} totalCount={laborCatalog?.totalCount} onDelete={handleDeleteClick} loading={isLoading} lazyParams={lazyParams} onPage={onPage} onEdit={handleEdit} th={th} />

            {<LaborCatalogDialog visible={dialogVisible} onHide={handleHide} onSubmit={handleSubmit} initialData={selectedItem} loading={isLoading} isEdit={isEdit} th={th} />}
        </div>
    );
};

export default LaborCatalogPage;
